module.exports = __webpack_public_path__ + "img/선릉역 미용실 2.0738ce7f.png";